module.exports = __webpack_public_path__ + "static/media/Logo_circle.c2de0bdd.jpg";